import models from "./inbox.models";
import dmModels from "./inbox.results.dm";
const results = [...models, ...dmModels];
export default {
  models: results
};